export default "__VITE_ASSET__qV4RRq6j__"